export class ODataOrder{
    constructor(private property:string, private isDescending:boolean = false){
        
    }

    public toString():string{
        if(this.isDescending){
            return this.property + " desc";
        }else{
            return this.property;
        }
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/utility/odata/odata-order.ts